import requestManager from "@comp/platformApi/requestManager";
import appHelper from "@util/appHelper";

export default {

    /**
     * hot keyword and keyword in search history
     */
    keywords : {
        url : '/portal/v4/index/ctrl'
    },

    cleanHistory : {
        url : '/portal/v4/index/ctrl',
        method : 'delete'
    },

    getSuggestions: function (keyword, callback) {
        return requestManager.request({
            url: 'portal/v4/index/search/sug',
            params: {
                keyword: keyword
            }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        });
    },



}
